import { jwtDecode } from 'jwt-decode'

import User from '@/types/user'

export const USER_TOKEN_KEY = '@atlas:v2:token'

interface CheckUserSessionProps {
  onInvalidToken?: () => void
}

export function checkUserSession({
  onInvalidToken,
}: CheckUserSessionProps = {}) {
  const sessionToken = localStorage.getItem(USER_TOKEN_KEY)
  if (!sessionToken) return null

  const user = jwtDecode(sessionToken) as User
  const expDate = new Date(user.exp * 1000)
  const now = new Date()
  const isValidToken = expDate > now

  if (!isValidToken) {
    onInvalidToken?.()
    return false
  }

  return { user, token: sessionToken }
}

export function setUserSession(token: string) {
  localStorage.setItem(USER_TOKEN_KEY, token)
}

export function removeUserSession() {
  localStorage.removeItem(USER_TOKEN_KEY)
}
